import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": ".7",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "stroke-width": "1.7",
      d: "M7.31 3.049a.96.96 0 0 0-.696-.122l-4.23.88a.96.96 0 0 0-.762.936v15.393a.957.957 0 0 0 1.206.925l4.375-1.178 4.758 1.182c.165.041.338.037.5-.01l3.982-1.17 4.747 1.18a.957.957 0 0 0 1.188-.929V5.183a.96.96 0 0 0-.713-.925l-4.999-1.32a.96.96 0 0 0-.775.13l-4.104 2.737z"
    }, null, -1),
    _createElementVNode("path", { d: "M6.861 12.777h1.346v-1.346H6.861zM6.861 15.285h1.346V13.94H6.861zM15.426 12.716h1.346V11.37h-1.346zM6.861 10.407h1.346V9.061H6.861zM15.426 10.346h1.346V9h-1.346zM15.426 15.285h1.346V13.94h-1.346z" }, null, -1)
  ]))]))
}
export default { render: render }